import MonetizationOnIcon from "@material-ui/icons/MonetizationOn";
import { token } from "functions/Helper";
import OnlineOrderList from "views/OnlineOrder/List";
import ViewOnlineOrder from "views/OnlineOrder/View";

const onlineOrder = () => {
  let views = [];

  if (
    token["order.online_orders.read"] === "allowed" ||
    token.is_admin === "True"
  ) {
    views.push({
      path: "/OnlineOrder/List",
      name: "Online Order",
      icon: MonetizationOnIcon,
      component: OnlineOrderList,
      layout: "/admin"
    });
  }
  return views;
};

const onlineOrderHidden = () => {
  const views = [];

  if (
    token["order.online_orders.read"] === "allowed" ||
    token.is_admin === "True"
  ) {
    views.push({
      path: "/OnlineOrder/View",
      name: "View Online Order",
      component: ViewOnlineOrder,
      layout: "/admin",
      params: [
        {
          name: "id"
        }
      ]
    });
  }
  return [
    {
      collapse: true,
      name: "Online Order Hidden",
      state: "onlineOrderHiddenCollapse",
      hideInSidebar: true,
      views: []
    }
  ];
};

export { onlineOrder, onlineOrderHidden };
